export default __webpack_public_path__ + "static/media/FakeJapanese03-AboutPhysicalArt.0da97ab5.svg";